import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  inputContainer: theme => css`
    margin-top: ${theme.spacing.xs};
    margin-bottom: ${theme.spacing.sm};
  `,
  container: theme => css`
    margin-top: ${theme.spacing.xs};
    margin-bottom: ${theme.spacing.sm};
  `,
})

export default useStyles
